import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../../../../Theme';

/**
 * Import Themes
 */

import inputOptionsBlogTheme from './_blog';
import inputOptionsSiteTheme from './_site';

/**
 * Group Themes
 */

const inputOptionsThemes = new MatchedMap([
  [ThemeEnum.Blog, inputOptionsBlogTheme],
  [ThemeEnum.Site, inputOptionsSiteTheme],
]);

/**
 * Theme Hook
 */

const useInputOptionsTheme = () => useTheme({}, inputOptionsThemes);

export default useInputOptionsTheme;
